<script lang="ts" setup>
const { t } = useI18n()

const stats = [
  { key: 'companies' },
  { key: 'scanned' },
  { key: 'requests' },
]
</script>

<template>
  <div class="rounded-2xl bg-gradient-to-b from-indigo-200/10 to-gray-50/10 p-4 shadow-sm shadow-indigo-500/10 ring-1 ring-indigo-200 lg:rounded-3xl lg:p-7 dark:from-indigo-900/10 dark:to-gray-900/10 dark:ring-indigo-900">
    <div class="flex flex-col divide-y divide-indigo-100 lg:flex-row lg:divide-x lg:divide-y-0 dark:divide-indigo-950">
      <div
        v-for="stat in stats"
        :key="stat.key"
        class="flex flex-1 flex-col items-center gap-y-4 p-6 text-center lg:p-10 lg:py-0"
      >
        <p class="text-primary font-mono text-sm uppercase tracking-tight">
          {{ t(`stats.${stat.key}.prefix`) }}
        </p>

        <p class="text-pretty text-3xl font-semibold tracking-tight sm:text-4xl lg:scale-110 dark:text-white">
          {{ t(`stats.${stat.key}.number`) }}
        </p>

        <p class="font-medium tracking-tight text-gray-700 dark:text-gray-300">
          {{ t(`stats.${stat.key}.label`) }}
        </p>

        <p class="text-secondary-foreground text-sm dark:text-gray-400">
          {{ t(`stats.${stat.key}.description`) }}
        </p>
      </div>
    </div>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "stats": {
      "companies": {
        "description": "Comprehensive data coverage across all industries and regions.",
        "label": "Companies in database",
        "number": "50M+",
        "prefix": "Over"
      },
      "requests": {
        "description": "Fast and scalable API built to handle enterprise workloads.",
        "label": "API requests served",
        "number": "40M+",
        "prefix": "Last 30 days"
      },
      "scanned": {
        "description": "Real-time data processing and enrichment capabilities.",
        "label": "Companies scanned",
        "number": "300K+",
        "prefix": "Last 24 hours"
      }
    }
  },
  "es": {
    "stats": {
      "companies": {
        "description": "Cobertura completa de datos en todas las industrias y regiones.",
        "label": "Empresas en la base de datos",
        "number": "50M+",
        "prefix": "Más de"
      },
      "requests": {
        "description": "API rápida y escalable construida para manejar cargas de trabajo empresariales.",
        "label": "Solicitudes de API servidas",
        "number": "40M+",
        "prefix": "Últimos 30 días"
      },
      "scanned": {
        "description": "Capacidades de procesamiento y enriquecimiento de datos en tiempo real.",
        "label": "Empresas escaneadas",
        "number": "300K+",
        "prefix": "Últimas 24 horas"
      }
    }
  },
  "fr": {
    "stats": {
      "companies": {
        "description": "Couverture complète des données dans toutes les industries et régions.",
        "label": "Entreprises dans la base de données",
        "number": "50M+",
        "prefix": "Plus de"
      },
      "requests": {
        "description": "API rapide et évolutive conçue pour gérer les charges de travail d'entreprise.",
        "label": "Requêtes API servies",
        "number": "40M+",
        "prefix": "30 derniers jours"
      },
      "scanned": {
        "description": "Capacités de traitement et d'enrichissement des données en temps réel.",
        "label": "Entreprises scannées",
        "number": "300K+",
        "prefix": "Dernières 24 heures"
      }
    }
  }
}
</i18n>
